import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Stack,
  Select,
  DialogActions,
  DialogTitle,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

import Typography from "@mui/material/Typography";

import Slide from "@mui/material/Slide";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";

import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { DesignationApis } from "../../../Data/axios";
// import HeaderDesignation from "./HeaderDesignation";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function Designation() {
  const [open, setOpen] = React.useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [name, setName] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [parent, setParent] = React.useState("");
  const [updateName, setUpdateName] = React.useState("");
  const [updateParentDesignation, setUpdateParentDesignation] =
    React.useState("");

  const [data, setData] = useState([]);
  const [designationData, setDesignationData] = useState([]);

  const [parentValue, setParentValue] = useState([]);

  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
    setUpdateName("");
    setUpdateParentDesignation("");
  };
  const Trainee = "Trainee";
  const Junior = "Junior";
  const Senior = "Senior";
  const TeamLead = "Team Lead";
  const ProjectManager = "Project Manager";
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
    setParent("");
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const response = await DesignationApis.getAll(currentPage, rowsPerPage);
    const { data, pagination } = response;
    // setDrivers(data);
    setDesignationData(data);
  }

  useEffect(() => {
    // Replace with your actual API endpoint
    const fetchData = async () => {
      try {
        const data = await DesignationApis.getParentValue();
        setParentValue(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const columns = [
    {
      name: "designation",
      label: "Designation",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Designation
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "parent",
      label: "Parent Designation",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Parent Designation
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Actions
            </th>
          );
        },
        customBodyRender: (value) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end", // Aligns content to the left
              alignItems: "center",
              paddingLeft: "20px", // Add padding for starting point
            }}
          >
            <Stack
              spacing={2}
              direction="row"
              sx={{
                justifyContent: "flex-end",
                "& .MuiButton-root": {
                  margin: "0 4px",
                },
              }}
            >
              <Button variant="outlined" onClick={() => handleEdit(value)}>
                <EditNoteIcon /> Update
              </Button>
              <Button variant="outlined" onClick={() => handleDelete(value)}>
                <DeleteForeverIcon /> Delete
              </Button>
            </Stack>
          </div>
        ),
      },
    },
  ];
  // const fetchDataDesignation = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://rptpl.roadpilot.co.in/public/api/getDesignation"
  //     );
  //     const data = await response.json();

  //     setDesignationList(data);
  //   } catch (err) {
  //     throw new Error("Failed to fetch data. Please try again later.");
  //   }
  // };
  // useEffect(() => {
  //   fetchDataDesignation();
  // }, []);

  async function handleEdit(id) {
    const result = designationData.filter((item) => item.id === id);

    setData(result[0]);

    handleClickUpdate();
  }
  useEffect(() => {
    setUpdateName(data.designation);
  }, [data.designation]);

  useEffect(() => {
    setUpdateParentDesignation(data.parent);
  }, [data.parent]);

  async function updateDesignation() {
    // const creator_name = localStorage.getItem("empid");
    const formData = new FormData();

    formData.append("designation", updateName);
    formData.append("parent", updateParentDesignation);
    // formData.append("creator", creator_name);
    try {
      await DesignationApis.update(data.id, formData);

      handleUpdateClose();

      getData();
      setName("");
      setParent("");
      showAlert("  Updated successfully", "success");
    } catch (error) {
      console.error(error);
      showAlert("Failed to update ", "error");
    }
  }

  async function handleDelete(id) {
    await DesignationApis.deletebyId(id);

    getData();
    showAlert(" Deleted Successfully!", "warning");
  }
  // const userInfoString = localStorage.getItem("user-info");

  // Parse the string into an object
  // const userInfo = JSON.parse(userInfoString);

  // Access the empid
  // const empid = userInfo?.value?.empid;
  async function AddDepartment() {
    const formData = new FormData();

    formData.append("designation", name);
    formData.append("parent", parent);

    // formData.append("creator", empid);

    await DesignationApis.add(formData);

    showAlert(" Added successfully", "success");

    getData();
    handleClose();
  }

  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Define reusable input styling to match Department component style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  return (
    <>
      {/* <HeaderDesignation /> */}
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="md"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              top: 0,
              right: 0,
              width: "calc(100% - 260px)", // Adjusted width to account for sidebar
              height: "100%",
              backgroundColor: "#f5f5f5",
              margin: 0,
              maxHeight: "100%",
              borderRadius: 0,
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
                sx={{ color: "#212121" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: "#212121" }} component="div">
                Update Designation
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
            <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Designation Name"
                      size="small"
                      value={updateName}
                      onChange={(e) => setUpdateName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Parent Designation
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={updateParentDesignation}
                      onChange={(e) => setUpdateParentDesignation(e.target.value)}
                      InputProps={inputProps}
                    >
                      <MenuItem value="">
                        <em>---</em>
                      </MenuItem>
                      {parentValue.map((option) => (
                        <MenuItem
                          key={option.designation}
                          value={option.designation}
                        >
                          {option.designation}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>

                <Box display="flex" gap={2} mt={3}>
                  <Button
                    onClick={updateDesignation}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Update
                  </Button>
                  <Button
                    onClick={handleUpdateClose}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Dialog>
      </React.Fragment>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none", margin: "5px 0 5px 0px" }}>
          <React.Fragment>
            <Stack direction="row" spacing={2}>
              <Box
                onClick={handleClickOpen}
                sx={{
                  backgroundColor: "#4285F4",
                  "&:hover": { backgroundColor: "#3367D6" },
                  textAlign: "center",
                  padding: "10px",
                  marginLeft: "10px",
                  height: "40px",
                  width: "155px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                  color: "#fff",
                }}
              >
                <AddIcon />
                Add Designation
              </Box>
            </Stack>
            <Dialog
              fullWidth
              maxWidth="md"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "calc(100% - 260px)", // Adjusted width to account for sidebar
                  height: "100%",
                  backgroundColor: "#f5f5f5",
                  margin: 0,
                  maxHeight: "100%",
                  borderRadius: 0,
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    sx={{ color: "#212121" }}
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
                    component="div"
                  >
                    New Designation
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
                <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                      Add Designation
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          placeholder="Designation Name"
                          size="small"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          InputProps={inputProps}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Parent Designation
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          value={parent}
                          onChange={(e) => setParent(e.target.value)}
                          InputProps={inputProps}
                        >
                          <MenuItem value="">
                            <em>---</em>
                          </MenuItem>
                          {parentValue.map((option) => (
                            <MenuItem
                              key={option.designation}
                              value={option.designation}
                            >
                              {option.designation}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>

                    <Box display="flex" gap={2} mt={3}>
                      <Button
                        onClick={AddDepartment}
                        variant="contained"
                        sx={{
                          bgcolor: "#4285F4",
                          color: "white",
                          "&:hover": { bgcolor: "#3367D6" },
                          fontWeight: 500,
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        onClick={handleClose}
                        variant="outlined"
                        sx={{
                          borderColor: "#bdbdbd",
                          color: "#424242",
                          "&:hover": {
                            borderColor: "#9e9e9e",
                            bgcolor: "rgba(0, 0, 0, 0.04)",
                          },
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        
        <Divider />
        <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Designations
                </span>
              }
              data={designationData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Designation;
